import React from "react"
import MyCard from "@common-utils/MyCard"
import KpiCharts from "./components/kpiCharts/KpiCharts"
import KpiForm from "./components/KpiForm"
import { KpiProvider } from "./components/KpiContext"

const DashboardKpi = () => {
     return (
          <KpiProvider>
               <MyCard classNames={"shadow-sm"}>
                    <MyCard.Header classNames="border-0 pt-5">
                         <div className="d-flex align-items-center">
                              <div className="symbol symbol-40px me-3">
                                   <div className="symbol-label bg-light-info">
                                        <i className="fas fa-chart-pie text-info fs-2" />
                                   </div>
                              </div>
                              <div className="d-flex flex-column">
                                   <h3 className="card-title fw-bolder text-gray-800 fs-3 mb-1">Mes Indicateurs</h3>
                                   <span className="text-muted fw-bold fs-7">Vue d'ensemble et performances</span>
                              </div>
                         </div>
                    </MyCard.Header>

                    <MyCard.Body>
                         <KpiForm />
                         <KpiCharts />
                    </MyCard.Body>
               </MyCard>
          </KpiProvider>
     )
}

export default DashboardKpi
